export const GRUPO_PRECO_CREATE = "GRUPO_PRECO_CREATE";
export const GRUPO_PRECO_UPDATE = "GRUPO_PRECO_UPDATE";
export const GRUPO_PRECO_LOAD = "GRUPO_PRECO_LOAD";
export const GRUPO_PRECO_LIST = "GRUPO_PRECO_LIST";
export const GRUPO_PRECO_REMOVE = "GRUPO_PRECO_REMOVE";
export const GRUPO_PRECO_UPDATE_PADRAO = "GRUPO_PRECO_UPDATE_PADRAO";
export const GRUPO_PRECO_VALIDA_CEP = "GRUPO_PRECO_VALIDA_CEP";
export const GRUPO_PRECO_SALVAR_CEP = "GRUPO_PRECO_SALVAR_CEP";
export const GRUPO_PRECO_LOAD_FAIXA_CEP = "GRUPO_PRECO_LOAD_FAIXA_CEP";
